<template>
  <div
    class="
      fixed
      pin
      h-screen
      w-full
      flex
      flex-col
      justify-center
      items-center
      text-white
      text-shadow
    "
    :style="{ background: copied.background }"
    v-if="copied">
      <p class="text-2xl uppercase">Copied!</p>
      <p class="text-5xl">{{ copied.text }}</p>
  </div>
</template>

<script>
export default {
  name: 'CopiedAlert',
  props: [
    'copied',
  ],
};
</script>
